import React, { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from './firebase'; // Ensure Firebase is correctly initialized

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [showModal, setShowModal] = useState(false);

    const handlePasswordReset = async () => {
        setMessage('');
        setError('');
        if (!email) {
          setError('Please enter your email address.');
          return;
        }

        try {
            await sendPasswordResetEmail(auth, email, {
              url: process.env.REACT_APP_RESET_PASSWORD_URL, // Use the environment variable
              handleCodeInApp: true, // Ensure the link opens in the app
            });
            setMessage('Password reset email sent! Check your inbox.');
            setShowModal(true); // ✅ Show modal after success
        } catch (err) {
            console.error('Error sending password reset email:', err.message);
            setError('Error sending password reset email. Please try again.');
        }
    };

    return (
      <div className="min-h-screen flex flex-col items-center justify-center px-4 py-10 bg-gray-50">
        {/* Logo */}
        <img
          src="/proactr_logo_dark.png"
          alt="ProACTR Logo"
          className="w-[350px] mb-6"
        />
    
        {/* Page Title */}
        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          Forgot Your Password?
        </h1>
        <p className="text-sm text-gray-600 max-w-md text-center mb-6">
          Don’t worry, it happens to the best of us. Just enter your email below, and we’ll help you get back on track.
        </p>
    
        {/* Form */}
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          className="w-full max-w-sm border border-gray-300 rounded px-4 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm"
        />
        <button
          onClick={handlePasswordReset}
          className="w-full max-w-sm bg-purple-700 hover:bg-purple-800 text-white font-medium py-2 px-4 rounded transition mb-4"
        >
          Send Reset Email
        </button>
    
        {/* Message Feedback */}
        {message && <p className="text-green-600 text-sm mb-2 text-center">{message}</p>}
        {error && <p className="text-red-600 text-sm mb-2 text-center">{error}</p>}
    
        {/* Back to Login */}
        <p className="text-sm text-gray-600 mt-4">
          Remembered your password?{' '}
          <a href="/" className="text-purple-700 hover:underline">
            Go back to Login
          </a>
        </p>
    
        {/* ✅ Modal for Success Message */}
        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md text-center">
              <h2 className="text-xl font-bold text-green-600 mb-2">Success!</h2>
              <p className="text-sm text-gray-700 mb-2">
                You will receive an email with a link to reset your password if an account exists.
              </p>
              <p className="text-sm text-gray-700 mb-6">
                Click the button below to go back to the login page.
              </p>
              <button
                onClick={() => (window.location.href = '/login')}
                className="bg-purple-700 hover:bg-purple-800 text-white px-4 py-2 rounded"
              >
                OK
              </button>
            </div>
          </div>
        )}
      </div>
    );  
}

export default ForgotPassword;
